import { loadingToggle } from "../include/module";
import { anchorLink } from "../include/module";
import { mvSlider } from "../include/module";
import { toggleMenu } from "../include/module";
import { projectToggle } from "../include/module";
import { moviePlay } from "../include/module";
import { scrollAnim } from "../include/module";
import { loadAnim } from "../include/module";
import { scrollPetal } from "../include/module";
import { toggleSidedeco } from "../include/module";
import { toggleParallax } from "../include/module";
import { fallingRose } from "../include/module";
import { randomChara } from "../include/module";





(() => {

  loadingToggle();
  anchorLink();
  mvSlider();
  toggleMenu();
  projectToggle();
  moviePlay();
  scrollAnim();
  loadAnim();
  scrollPetal();
  toggleSidedeco();
  // toggleParallax();
  fallingRose();
  randomChara();

})();



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js